import React from 'react';
import sslImg from '../../assets/Images/sslsecure.png'
const Button = ({ sslSecure, btnName, style, onClick, disabled , btnshadow, smallsize}) => {
  
  return (
      <div className={btnshadow === "true" ? "flexbutton sticky-button-container buttonuppershadow" : "flexbutton sticky-button-container "}>

      <button
        className={smallsize === "true" ? 'continue-button-small mb-12 mt-23': 'continue-button mb-12 mt-23'}
        style={style}
        onClick={onClick}
        disabled={disabled}
      >
        {btnName}
      </button>
      {sslSecure === "true" &&
      <img src={sslImg} width={87} height={23} />}
    </div>
  );
};

export default Button;
